import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_NurseFu = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_NurseFu' className='file-pdf-document'>
            <div className='file-template'>




                <h3 >
                    <center>PROGRESS NOTE FOR NURSES </center></h3>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INSURANCE #:</span>
                            <input type="text" id="txtInsurance" name="txtInsurance" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbNursingAssessment" name="cbNursingAssessment" className='add-only' value="NURSING ASSESSMENT (T1001 U3 U6)" />
                            NURSING ASSESSMENT (T1001 U3 U6)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMedicationAdministration" name="cbMedicationAdministration" className='add-only' value="MEDICATION ADMINISTRATION INJECTION (96372 U3 U6)" />
                            MEDICATION ADMINISTRATION INJECTION (96372 U3 U6)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOmprehensiveMedication" name="cbOmprehensiveMedication" className='add-only' value="OMPREHENSIVE MEDICATION ADMINISTRATION (H2010 U3 U6)" />
                            OMPREHENSIVE MEDICATION ADMINISTRATION (H2010 U3 U6)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOther" name="cbOther" className='add-only' value="OTHER" />
                            OTHER:
                            <input type="text" id="txtOther" name="txtOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PROVIDER NAME AND TITLE:</span>
                            <input type="text" id="txtProviderName" name="txtProviderName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PROVIDER LEVEL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbProviderLevel_1" name="rbProviderLevel" value="" className='add-only' /> U6 In-Clinic
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbProviderLevel_2" name="rbProviderLevel" value="" className='add-only' /> U7 Out-of-Clinic
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>DELIVERY METHOD: </span>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbDeliveryMethod_1" name="rbDeliveryMethod" className='add-only' value="Face to Face" />  Face to Face &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbDeliveryMethod_2" name="rbDeliveryMethod" className='add-only' value="Indirect" /> Indirect
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>LOCATION OF SERVICE:</span>
                            <input type="text" id="txtLocationOfService" name="txtLocationOfService" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>APPOINTMENT TYPE: </span>
                            <input type="text" id="txtAppointmentType" name="txtAppointmentType" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>BILLABLE SERVICE:</span>
                            <input type="radio" id="rbBillableService_1" name="rbBillableService" className='add-only' value="Yes" /> Yes &nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbBillableService_2" name="rbBillableService" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># Seen:</span>
                            <input type="text" id="txtSeen" name="txtSeen" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DATE OF NEXT VISIT:</span>
                            <input id="txtDateOfNextVisit" name="txtDateOfNextVisit" className='add-only' type='date' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>CLIENT IDENTIFICATION CONFIRMED: </span>
                <span className='small'>Through third party present and state issued picture identification </span>
                <textarea id="txtClientIdentificationConfirmed" name="txtClientIdentificationConfirmed" className='add-only' ></textarea>
                <table>
                    <tr>
                        <td className='w-750'>
                            <h4>FSBS:</h4>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Collection Time: </span>
                            <input type="text" id="txtCollectionTime" name="txtCollectionTime" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Non Fasting:</span>
                            <input type="text" id="txtNonFasting" name="txtNonFasting" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Fasting:</span>
                            <input type="text" id="txtFasting" name="txtFasting" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>BMI:</span>
                            <input type="text" id="txtBMI" name="txtBMI" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h4>VITALS:</h4>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Temperature:</span>
                            <input type="text" id="txtTemperature" name="txtTemperature" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Pulse:</span>
                            <input type="text" id="txtPulse" name="txtPulse" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Respiration:</span>
                            <input type="text" id="txtRespiration" name="txtRespiration" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Weight:</span>
                            <input type="text" id="txtWeight" name="txtWeight" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h4>BP:</h4>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Sitting Right: </span>
                            <input type="text" id="txtSittingRight" name="txtSittingRight" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Sitting Left: </span>
                            <input type="text" id="txtSittingLeft" name="txtSittingLeft" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>LAB TEST FOR: </span>
                            <input type="text" id="txtLabTest" name="txtLabTest" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>LAB DRAWN FROM: </span>
                            <input type="text" id="txtLabDrawn" name="txtLabDrawn" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>NEEDLE SIZE USED: </span>
                            <input type="text" id="txtNeedleSize" name="txtNeedleSize" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNo" name="cbNo" className='add-only' value="No" />
                            No S&S
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBleeding" name="cbBleeding" className='add-only' value="Bleeding" />
                            Bleeding
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSwelling" name="cbSwelling" className='add-only' value="Swelling" />
                            Swelling
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHematoma" name="cbHematoma" className='add-only' value="Hematoma" />
                            Hematoma
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>INJECTION:</span>
                            <input type="text" id="txtInjection" name="txtInjection" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>SITE:</span>
                            <input type="text" id="txtSite" name="txtSite" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>TOLERATED:</span>
                            <input type="text" id="txtTolerated" name="txtTolerated" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>MEDICATION SIDE EFFECTS: </span>
                            <input type="text" id="txtMedicationSideEffects" name="txtMedicationSideEffects" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PAIN ASSESSMENT:</span>
                            <input type="radio" id="rbPainAssessment_None" name="rbPainAssessment" className='add-only' value="None" /> None &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbPainAssessment_Yes" name="rbPainAssessment" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>RECENT HOSPITALIZATION</span>
                            <input type="radio" id="rbRecentHospitalization_No" name="rbRecentHospitalization" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRecentHospitalization_Yes" name="rbRecentHospitalization" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>LOCATION:</span>
                            <input type="text" id="txtLocation" name="txtLocation" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>INTERVENTIONS / SKILLS TAUGHT / HANDOUTS USED / EDUCATION ABOUT MENTAL ILLNESS, RISK & BENEFITS OF TREATMENT, MEDICATIONS: </span>
                    <textarea id="txtInterventions" name="txtInterventions" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>PLAN:</span>
                    <textarea id="txtPlan" name="txtPlan" className='add-only'></textarea>
                </p>
                <h4>
                    <center>
                        ABNORMAL INVOLUNTARY MOVEMENT SCALE(AIMS)
                        <br />
                        Alcohol, Drug Abuse, and Mental Health Administration
                    </center>
                </h4>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><strong>INSTRUCTIONS: </strong>Complete Examination procedure (attachment d.) Before making ratings </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>MOVEMENT RATINGS:</strong>Rate highest severity observed. Rate
                                movements that occur upon activation one less than those observed spontaneously. </span>
                        </td>
                        <td className='w-300'>
                            <span><strong>CODE &nbsp;</strong></span>
                            <span ><strong> &nbsp;0=None,   &nbsp;1=Minimal, may be extreme normal </strong></span>
                            <span ><strong>2=Mild, 3=Moderate,  4 Severe </strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span>Circle movement as well as code number that applies. </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'> Facial and Oral Movements </span> </td>
                        <td className='w-300'><span className='eleHeader'> Rater: </span> </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>1. Muscles of Facial Expression (e.g movements of forehead, eyebrows. penorbital area.
                                cheeks, including frowning. blinking, smiling, grimacing)</strong></span>
                            <span>(e.g movements of forehead, eyebrows. penorbital area.
                                cheeks, including frowning. blinking, smiling, grimacing )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_1_1" name="rbRater_1" className='add-only' value="0" /> 0 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_2" name="rbRater_1" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_3" name="rbRater_1" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_4" name="rbRater_1" className='add-only' value="3" /> 3 &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_1_5" name="rbRater_1" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>2. Lips and Perioral Area </strong></span>
                            <br />
                            <span>(e.g.. puckering, pouting, smacking )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_2_1" name="rbRater_2" className='add-only' value="0" /> 0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_2" name="rbRater_2" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_3" name="rbRater_2" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_4" name="rbRater_2" className='add-only' value="3" /> 3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_2_5" name="rbRater_2" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>3. Jaw </strong></span><br />
                            <span>(e.g. biting, clenching. chewing. mouth opening, lateral movement )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_3_1" name="rbRater_3" className='add-only' value="0" />  0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_2" name="rbRater_3" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_3" name="rbRater_3" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_4" name="rbRater_3" className='add-only' value="3" /> 3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_3_5" name="rbRater_3" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>4. Tongue Rate </strong></span>
                            <span>(only increases in movement both in and out
                                of mouth. NOT inability to sustain movement. Darting in
                                and Out -Of rrrOutfr.)</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" id="rbRater_4_1" name="rbRater_4" className='add-only' value="0" /> 0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_2" name="rbRater_4" className='add-only' value="1" /> 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_3" name="rbRater_4" className='add-only' value="2" /> 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_4" name="rbRater_4" className='add-only' value="3" />  3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_4_5" name="rbRater_4" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Extremity Movements</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>5. Upper (arms, wrists„ hands, fingers) </strong></span>
                            <span>Include choreic movements (i.e., rapid, objectively purposeless.
                                Irregular, spontaneous) athetoid movements (i.e. slow, irregular,
                                complex, serpentine). DO NOT INCLUDE TREMOR
                                (i.e.. repetitive. regular, rhythmic) </span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_5_1" name="rbRater_5" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_2" name="rbRater_5" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_3" name="rbRater_5" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_4" name="rbRater_5" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_5_5" name="rbRater_5" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>6. Lower (legs, knees, ankles, toes) </strong></span>
                            <span>(e.g.. lateral knee movement. foot tapping, heel dropping. foot
                                squirming. inversion and eversion of foot.) </span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_6_1" name="rbRater_6" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_2" name="rbRater_6" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_3" name="rbRater_6" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_4" name="rbRater_6" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_6_5" name="rbRater_6" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Trunk Movements</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>7. Neck, shoulders, hips </strong></span>
                            <span>(e.g . rocking, twisting, squirming, pelvic gyrations )</span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_7_1" name="rbRater_7" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_2" name="rbRater_7" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_3" name="rbRater_7" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_4" name="rbRater_7" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_7_5" name="rbRater_7" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Global Judgments</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>8. Severity of abnormal movements overall </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_8_1" name="rbRater_8" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_2" name="rbRater_8" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_3" name="rbRater_8" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_4" name="rbRater_8" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_8_5" name="rbRater_8" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>9. Incapacitation due to abnormal movements </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_9_1" name="rbRater_9" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_2" name="rbRater_9" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_3" name="rbRater_9" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_4" name="rbRater_9" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_9_5" name="rbRater_9" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>10. Patient's awareness of abnormal movements</strong></span>
                            <span>(Rate only patient's report No awareness 0 Aware, no distress 1 Aware, mild distress 2 Aware, moderate distress 3 Aware, severe distress 4) </span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_10_1" name="rbRater_10" className='add-only' value="0" /> 0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_2" name="rbRater_10" className='add-only' value="1" /> 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_3" name="rbRater_10" className='add-only' value="2" /> 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_4" name="rbRater_10" className='add-only' value="3" /> 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_10_5" name="rbRater_10" className='add-only' value="4" /> 4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>11. Do movements disappear in sleep? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_11_1" name="rbRater_11" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_11_2" name="rbRater_11" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'> Dental Status</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Rater: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>12. Current problems with teeth and/or dentures? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_12_1" name="rbRater_12" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_12_2" name="rbRater_12" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>13. Are dentures usually worn? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" id="rbRater_13_1" name="rbRater_13" className='add-only' value="No" /> No&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_13_2" name="rbRater_13" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span><strong>14. Edentia? </strong></span>
                        </td>
                        <td className='w-300'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" id="rbRater_14_1" name="rbRater_14" className='add-only' value="No" /> No &nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="rbRater_14_2" name="rbRater_14" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}